// pages/404.tsx
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

export default function Custom404() {
  const router = useRouter()

  useEffect(() => {
    const path = window.location.pathname

    if (path.includes('/vendas')) {
      router.replace('/imoveis/venda/-/-/-/-')
      return
    }
    if (path.includes('/lancamento')) {
      router.replace('/imoveis/venda/-/-/-/-?categoria=1')
      return
    }
    if (path.includes('/parceiros')) {
      const [agenciador, , imovelId] = path.split('/').slice(-3)
      router.replace(`/imovel/${imovelId}?verfts=1&agenciador=${agenciador}`)
      return
    }
    if (path.includes('/menu/')) {
      const menu = path.split('/').pop()
      router.replace(`/menu/${menu}`)
      return
    }
    if (path.includes('/comparar')) {
      router.replace('/comparar')
      return
    }
    if (path.includes('/promocao')) {
      router.replace('/imoveis/venda/-/-/-/-?promocao=1')
      return
    }

    // Se chegou aqui, nenhuma condição bateu → permanece nesta página 404
  }, [router])

  // UI da 404
  return (
    <main
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        textAlign: 'center',
        padding: '1rem',
      }}
    >
      <h1 style={{ fontSize: '2.5rem', margin: '0.5rem 0' }}>
        404 – Página não encontrada
      </h1>
      <p style={{ fontSize: '1.125rem', margin: '0.5rem 0 2rem' }}>
        Ops! A rota que você tentou acessar não existe.
      </p>
      <Link href="/" passHref>
        <button
          style={{
            padding: '0.75rem 1.5rem',
            fontSize: '1rem',
            borderRadius: '0.5rem',
            border: 'none',
            cursor: 'pointer',
            backgroundColor: '#0070f3',
            color: '#fff',
          }}
        >
          Voltar ao site
        </button>
      </Link>
    </main>
  )
}
